import React from 'react'
import { Page } from '../../components/page'
import Signup from '../../blocks/signup'

export default () => (
  <Page name="SIGNUP" title="Sign up">
    <Signup />
  </Page>
)
